<template>
  <div>
    <div ref="editor"
         style="text-align:left"
         v-loading="loading"></div>
    <el-upload :action="imgUpload"
               :on-success="handleFileSuccess"
               multiple
               :headers="isOverSea"
               :file-list="fileList"
               :before-upload="beforeUploadFile">
      <el-button size="small"
                 type="primary"
                 title="在正文光标处加上视频文件">上传本地视频文件</el-button>
    </el-upload>
  </div>
</template>
<script>
import E from 'wangeditor';
import api from '../../api/api';

export default {
  name: 'editor',
  data() {
    return {
      editorContent: '',
      imgUpload: `${api.url}upload`,
      fileList: [],
      hasFile: '',
      loading: false,
    };
  },
  methods: {
    handleFileSuccess(file) {
      this.fileList = [];
      const _ = this;
      if (file.ret === 0) {
        const isOverSea = localStorage.getItem('is_overSea');
        let publicUrl = '';
        if (isOverSea === 'true') {
          publicUrl = `${api.url}public/upload/overseas/${file.url}`;
        } else {
          publicUrl = `${api.url}public/upload/home/${file.url}`;
        }
        _.editor.cmd.do(
          'insertHTML',
          `<p><iframe src='${publicUrl}'></iframe></p><p><br></p>`,
        );
        _.editor.selection.restoreSelection();
      } else {
        this.$message.error('上传失败，请重新上传~');
      }
    },
    beforeUploadFile(file) {
      const extension = file.type === 'video/mp4';
      const isLt2M = file.size / 1024 / 1024 < 100;
      if (!extension) {
        this.$message.error('上传视频只支持mp4格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传视频大小不超过100M!');
      }
    },
  },
  computed: {
    isOverSea() {
      const object = {};
      object.isOverSea = this.$store.state.is_overSea;
      return object;
    },
    editContent() {
      return this.$store.state.editContent;
    },
  },
  watch: {
    editContent(text) {
      this.editor.txt.html(text);
    },
  },
  mounted() {
    this.$store.commit('getEditorContent', '');
    const editor = new E(this.$refs.editor);
    const isOverSea = localStorage.getItem('is_overSea');
    editor.customConfig.uploadImgHeaders = {
      isOverSea,
    };
    editor.customConfig.uploadImgServer = `${api.url}upload`;
    editor.customConfig.uploadImgMaxSize = 3 * 1024 * 1024;
    editor.customConfig.uploadFileName = 'file';
    editor.customConfig.menus = [
      'head', // 标题
      'bold', // 粗体
      'fontSize', // 字号
      'fontName', // 字体
      'italic', // 斜体
      'underline', // 下划线
      'strikeThrough', // 删除线
      'foreColor', // 文字颜色
      'link', // 插入链接
      'list', // 列表
      'justify', // 对齐方式
      'quote', // 引用
      'emoticon', // 表情
      'image', // 插入图片
      'table', // 表格
      'video', // 插入视频
      'code', // 插入代码
      'undo', // 撤销
      'redo', // 重复
    ];
    // 字体
    editor.customConfig.fontNames = [
      '宋体',
      '黑体',
      '楷体',
      '新宋体',
      '仿宋',
      'Arial',
      'Verdana',
      'Tahoma',
      'Georgia',
    ];
    editor.customConfig.zIndex = 1000;
    editor.customConfig.uploadImgHooks = {
      customInsert(insertImg, result) {
        let url = '';
        if (isOverSea === 'true') {
          url = `${api.url}public/upload/overseas/${result.url}`;
        } else {
          url = `${api.url}public/upload/home/${result.url}`;
        }
        insertImg(url);
      },
    };
    // eslint-disable-next-line func-names
    editor.customConfig.pasteTextHandle = function (content) {
      if (content === '' && !content) return '';
      let str = content;
      str = str.replace(/<xml>[\s\S]*?<\/xml>/ig, '');
      str = str.replace(/background-color[\s:]+[^;]*;/ig, '');
      str = str.replace(/background[\s:]+[^;]*;/ig, '');
      str = str.replace(/微软雅黑/ig, '');
      str = str.replace(/Microsoft YaHei/ig, '');
      // 1. remove line breaks / Mso classes
      const stringStripper = /(\n|\r| class=(")?Mso[a-zA-Z]+(")?)/g;
      str = str.replace(stringStripper, ' ');
      // 2. strip Word generated HTML comments
      const commentSripper = new RegExp('<!--(.*?)-->', 'g');
      str = str.replace(commentSripper, '');
      let tagStripper = new RegExp(
        '<(/)*(meta|link|span|\\?xml:|st1:|o:|font)(.*?)>',
        'gi',
      );
      // 3. remove tags leave content if any
      str = str.replace(tagStripper, '');
      // 4. Remove everything in between and including tags '<style(.)style(.)>'
      const badTags = [
        'style',
        'script',
        'applet',
        'embed',
        'noframes',
        'noscript',
      ];

      for (let i = 0; i < badTags.length; i += 1) {
        tagStripper = new RegExp(
          `<${badTags[i]}.*?${badTags[i]}(.*?)>`,
          'gi',
        );
        str = str.replace(tagStripper, '');
      }
      // 5. remove attributes ' style="..."'
      const badAttributes = ['style', 'start'];
      for (let i = 0; i < badAttributes.length; i += 1) {
        const attributeStripper = new RegExp(
          ` ${badAttributes[i]}="(.*?)"`,
          'gi',
        );
        str = str.replace(attributeStripper, '');
      }
      return str;
    };

    this.editor = editor;
    this.$emit('getEditor', editor);
    editor.create();
  },
};
</script>
<style scoped>
iframe {
  width: 640px;
  height: 320px;
}
</style>



// WEBPACK FOOTER //
// src/components/wangEditor/wangEditor.vue